module.exports = __webpack_public_path__ + "static/swimming-pool-liability-21ca13414330b751f06821d281906c87.jpg";